import { getRandom } from '../Utils/Utils';

export enum GameAudio {
    CHEST_OPEN = 'ChestOpen',
    TAP = 'tap',
    WHOOSH_IN = 'whoosh_in',
    WHOOSH_OUT = 'whoosh_out',
    BOOSTER_IN = 'BoosterIn',
    BOOSTER_OUT = 'BoosterOut',
    FIREWORKS_1 = 'FireworksCluster_1',
    FIREWORKS_2 = 'FireworksCluster_2',
    FIREWORKS_3 = 'FireworksCluster_3',
    FIREWORKS_4 = 'FireworksCluster_4',
    FIREWORKS_5 = 'FireworksCluster_5',
    FIREWORKS_6 = 'FireworksCluster_6',
    FIREWORKS_7 = 'FireworksCluster_7',
    FIREWORKS_8 = 'FireworksCluster_8',
    FIREWORKS_9 = 'FireworksCluster_9',
    FIREWORKS_10 = 'FireworksCluster_10',
    FIREWORKS_11 = 'FireworksCluster_11',
    FIREWORKS_EXPLODE = 'FireworksExplode',
    FIREWORKS_LAUNCH = 'FireworksLaunch',
    FLASHLIGHT = 'FlashlightActivate',
    FLASHLIGHT_CLICK = 'FlashlightClick',
    LAUNCH_TILE = 'LaunchTile',
    MAGNET_START = 'MagnetBuildUp',
    MAGNET_MOVE = 'MagnetSuckIn',
    MAGNET_END = 'MagnetDisappear',
    HINT = 'MagnifierActivate',
    MATCH_TILE_1 = 'MatchTile1',
    MATCH_TILE_2 = 'MatchTile2',
    MATCH_TILE_3 = 'MatchTile3',
    MATCH_TILE_4 = 'MatchTile4',
    MATCH_TILE_5 = 'MatchTile5',
    MATCH_TILE_6 = 'MatchTile6',
    MATCH_TILE_7 = 'MatchTile7',
    MATCH_TILE_8 = 'MatchTile8',
    MATCH_TILE_9 = 'MatchTile9',
    MATCH_TILE_10 = 'MatchTile10',
    MATCH_TILE_11 = 'MatchTile11',
    MATCH_TILE_12 = 'MatchTile12',
    MATCH_GOLD = 'MatchGold',
    PRIZEWHEEL_REWARD = 'Prizewheel_Reward',
    PRIZEWHEEL_SPIN = 'Prizewheel_Spin',
    REWARD_APPEAR = 'RewardAppear',
    REWARD_MOVE = 'RewardMove',
    REWARD_OPEN = 'RewardOpen',
    TILE_SELECT = 'SelectTile',
    SHUFFLE_POPUP = 'ShuffleBanner',
    SHUFFLE_SOUND = 'ShuffleShufling',
    SHUFFLE_TILE = 'ShuffleTiles',
    FERRET_YAHOO = 'ShuffleYahoo',
    STAR_1 = 'stars_1',
    STAR_2 = 'stars_2',
    STAR_3 = 'stars_3',
    STARS_ALL = 'Stars',
    STUCK_JINGLE = 'StuckJingle',
    WIN_POPUP = 'WinBanner',
    WIN_CHEER = 'WinCheer',
    WIN_FIREWORKS = 'WinFireworks',
    WIN_JINGLE = 'WinJingle',
    TILE_UNSELECTABLE = 'WrongTile',
}

interface IAudioSprites {
    [key: string]: IAudioSprite;
}

interface IAudioSprite {
    urls: string[];
    sprite: ISpriteData;
}

interface ISpriteData {
    [key: string]: number[];
}

export const GameMusicIds: string[] = ['map-music', 'game-music'];

export const AudioSpritesData: IAudioSprites = {};

export const getStarSound = (index: number) => {
    // @ts-ignore
    return GameAudio[`STAR_${index}`];
};

export const getMatchSound = (index: number) => {
    // @ts-ignore
    return GameAudio[`MATCH_TILE_${index}`];
};

export const getFireworkSound = (index?: number) => {
    const soundIndex = index || getRandom(1, 11);
    // @ts-ignore
    return GameAudio[`FIREWORKS_${soundIndex}`];
};

export const MUSIC_VOLUME = 0.2;
export const SOUND_VOLUME = 1.0;
